import type { AsyncJobFailedObject } from '@core/types/api/AsyncJobFailedObject/AsyncJobFailedObject';

import { useSlabQuery } from '../../hooks/useSlabQuery';

type AsyncJobFailedObjectIds = {
  failedObjectIds: string[];
  failedObjects: AsyncJobFailedObject[];
  itemsFailed: number;
  isLoading: boolean;
  isError: boolean;
};

export const useAsyncJobFailedObjectIds = (
  jobId: string,
  enabled: boolean,
  refetchInterval?: number | false,
): AsyncJobFailedObjectIds => {
  const { data, isLoading, isError } = useSlabQuery(
    'GET async job detail',
    {
      pathParams: { id: jobId },
    },
    {
      enabled,
      staleTime: 0,
      refetchInterval,
    },
  );

  return {
    failedObjectIds: data?.failedObjectIds ?? [],
    failedObjects: data?.failedObjects ?? [],
    itemsFailed: data?.itemsFailed ?? 0,
    isLoading,
    isError,
  };
};
